import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {
  Mapping,
  MappingAttribute,
  MappingScopeType,
  MappingQueryParams,
  MappingSearchResponse,
  MappingInput,
  MappingIdentifier
} from '../../model/models';

@Injectable({
  providedIn: 'root'
})
export class MappingService {

  constructor(private http: HttpClient) { }

  getMappings(attribute: MappingAttribute, scopeType: MappingScopeType, scopeValue: string, options?: MappingQueryParams): Observable<MappingSearchResponse> {
    let params = new HttpParams();
    if (options) {
      for (const [key, value] of Object.entries(options)) {
        if (value !== undefined && value !== null && value !== '') {
          params = params.set(key, value);
        }
      }
    }

    return this.http.get<MappingSearchResponse>(this.url(attribute, scopeType, scopeValue), { params });
  }

  createMapping(attribute: MappingAttribute, scopeType: MappingScopeType, scopeValue: string, mapping: MappingInput): Observable<Mapping> {
    return this.http.put<Mapping>(this.url(attribute, scopeType, scopeValue), mapping);
  }

  deleteMapping(attribute: MappingAttribute, scopeType: MappingScopeType, scopeValue: string, identifier: MappingIdentifier): Observable<any> {
    return this.http.delete(this.url(attribute, scopeType, scopeValue), { body: identifier });
  }

  private url(attribute: MappingAttribute, scopeType: MappingScopeType, scopeValue: string): string {
    return `${environment.yomaApiURL}/mappings/${attribute}/${scopeType}/${encodeURIComponent(scopeValue)}`;
  }
}
